export const slugs = {
  "sign-up": {
    de: "anmelden",
    it: "registrazione",
    fr: "inscription"
  },
  "help/flight-support": {
    de: "hilfe/hilfe-bei-flugen",
    it: "aiuto/supporto-voli",
    fr: "aide/support-vol"
  },
  "help/my-requests": {
    de: "hilfe/meine-anfragen",
    it: "aiuto/le-mie-richieste",
    fr: "aide/mes-demandes"
  },
  "help/royal-orchid-plus-services": {
    de: "hilfe/hilfe-bei-royal-orchid-plus",
    it: "aiuto/servizi-royal-orchid-plus",
    fr: "aide/services-royal-orchid-plus"
  },
  "help/service-request": {
    de: "hilfe/serviceanfrage",
    it: "aiuto/richiesta-servizi-speciali-e-assistenza",
    fr: "aide/demande-services"
  },
  "help/feedback": {
    de: "hilfe/feedback",
    it: "aiuto/feedback",
    fr: "aide/retours-et-avis"
  },
  "help/lost-and-found": {
    de: "hilfe/lost-and-found",
    it: "aiuto/oggetti-smarriti",
    fr: "aide/objets-trouves"
  },
  "help/flight-certificate": {
    de: "hilfe/flugbescheinigung",
    it: "aiuto/richiesta-certificato-volo",
    fr: "aide/certificat-de-vol"
  },
  "help/flight-disruption/compensation": {
    it: "aiuto/richiesta-compensazione",
    fr: "aide/perturbations-vol/indemnisation"
  },
  "help/flight-disruption/refund-airfare-fee": {
    it: "aiuto/richiesta-rimborso-tariffa",
    fr: "aide/perturbations-vol/remboursement-billet"
  },
  "help/flight-support/correct-name-spelling": {
    it: "aiuto/assistenza-volo/ortografia-nome-passeggero",
    fr: "aide/assistance-vol/correction-nom"
  },
  "help/flight-support/online-booking-support": {
    it: "aiuto/assistenza-volo/prenotazione-online",
    fr: "aide/assistance-vol/support-reservation-en-ligne"
  },
  "royal-orchid-plus-services/royal-orchid-plus-general-inquiries": {
    de: "royal-orchid-plus-services/allgemeine-fragen-zu-royal-orchid-plus",
    it: "servizio-royal-orchid-plus/domande-generiche-su-royal-orchid-plus",
    fr: "royal-orchid-plus/demandes-generales"
  },
  "help/service-request/purchase-extra-seat": {
    de: "hilfe/serviceanfrage/extre-sitz-kaufen",
    it: "aiuto/richiesta-servizi-speciali-e-assistenza/richiesta-acquisto-posto-extra",
    fr: "aide/demande-services/achat-siege-supplementaire"
  },
  "help/service-request/travel-with-pet": {
    de: "hilfe/serviceanfrage/befoerderung-von-tieren",
    it: "aiuto/richiesta-servizi-speciali-e-assistenza/viaggiare-con-animali",
    fr: "aide/demande-services/voyager-avec-animal"
  },
  "help/service-request/travel-with-equipment": {
    de: "hilfe/serviceanfrage/reisen-mit-sondergepack",
    it: "aiuto/richiesta-servizi-speciali-e-assistenza/viaggiare-con-bagagli-speciali-o-merci-pericolose",
    fr: "aide/demande-services/voyager-avec-equipement"
  },
  "help/service-request/baby-bassinet": {
    de: "hilfe/serviceanfrage/reisen-mit-kindern",
    it: "aiuto/richiesta-servizi-speciali-e-assistenza/richiesta-culla-per-neonati",
    fr: "aide/demande-services/lit-bebe"
  },
  "help/service-request/request-wheel-chair": {
    de: "hilfe/serviceanfrage/rollstuhl-anfragen",
    it: "aiuto/richiesta-servizi-speciali-e-assistenza/richiesta-sedia-a-rotelle",
    fr: "aide/demande-services/demande-fauteuil-roulant"
  },
  "help/service-request/passenger-with-difficulty": {
    de: "hilfe/serviceanfrage/reisen-mit-unterstutzungsbedarf",
    it: "aiuto/richiesta-servizi-speciali-e-assistenza/passeggeri-con-disabilità",
    fr: "aide/demande-services/mobilite-reduite"
  },
  "help/service-request/seating-sick": {
    de: "hilfe/serviceanfrage/stretcher",
    it: "aiuto/richiesta-servizi-speciali-e-assistenza/passeggeri-malati-o-in-barella",
    fr: "aide/demande-services/placement-passager-malade"
  },
  "help/service-request/unaccompanied-minor": {
    de: "hilfe/serviceanfrage/alleinreisende-kinder",
    it: "aiuto/richiesta-servizi-speciali-e-assistenza/minori-non-accompagnati",
    fr: "aide/demande-services/enfant-voyageant-seul"
  },
  "help/service-request/request-portable-oxygen": {
    de: "hilfe/serviceanfrage/extra-sauerstoff-an-bord",
    it: "aiuto/richiesta-servizi-speciali-e-assistenza/viaggiare-con-bombola-ossigeno",
    fr: "aide/demande-services/oxygene-portable"
  },
  "help/service-request/request-purchase-oxygen": {
    de: "hilfe/serviceanfrage/extra-sauerstoff-an-bord",
    it: "aiuto/richiesta-servizi-speciali-e-assistenza/richiesta-acquisto-ossigeno",
    fr: "aide/demande-services/achat-oxygene"
  },
  "help/lost-and-found/loss-of-personal-items-in-cabin": {
    it: "aiuto/oggetti-smarriti/smarrimento-oggetti-personali-in-cabina",
    fr: "aide/objets-perdus/perte-en-cabine"
  },
  "help/lost-and-found/baggage-claim-form": {
    it: "aiuto/oggetti-smarriti/modulo-reclamo-bagagli",
    fr: "aide/objets-perdus/formulaire-bagages"
  },
  "plan-trip/flight-schedule": {
    de: "planen/flugplan",
    it: "pianifica/orario-voli",
    fr: "planifier/horaires-vols"
  },
  "book/book-flight": {
    de: "fluge-buchen/fluge-buchen",
    it: "prenota/prenota-voli",
    fr: "reservation/vol"
  },
  "book/my-trips": {
    de: "fluge-buchen/meine-reisen",
    it: "prenota/i-miei-viaggi",
    fr: "reservation/mes-voyages"
  },
  "book/e-Receipt": {
    de: "fluge-buchen/e-Quittung",
    it: "prenota/ricevuta-elettronica",
    fr: "reservation/recu-electronique"
  },
  "book/flight-status": {
    de: "fluge-buchen/flugstatus",
    it: "prenota/prenota-voli/stato-del-volo",
    fr: "reservation/statut-vol"
  },
  "travel-information/baggage/baggage-tracking": {
    de: "info-und-service/gepack/nachverfolgung-des-aufgegeben-Gepacks",
    it: "informazioni-di-viaggio/bagagli/tracciamento-bagaglio",
    fr: "info-voyage/bagages/suivi-bagages"
  },
  "experience/ground-services/gold-track": {
    de: "reiseerlebnis/service-am-flughafen/gold-track",
    it: "esperienza/servizi-a-terra/gold-track",
    fr: "experience/services-sol/gold-track"
  },
  "rop/miles-calculator": {
    de: "rop/meilen-rechner",
    it: "rop/calcolatore-miglia",
    fr: "royal-orchid-plus/calculateur-miles"
  },
  "rop/reset-password": {
    de: "rop/passwort-zurucksetzen",
    it: "rop/reimposta-password",
    fr: "royal-orchid-plus/reinitialiser-mot-de-passe"
  },
  "rop/my-profile/change-password": {
    de: "rop/mein-profil/passwort-andern",
    it: "rop/il-mio-profilo/modifica-password",
    fr: "royal-orchid-plus/profil/modifier-mot-de-passe"
  },
  "rop/my-profile?tabSelected=nominee": {
    de: "rop/mein-profil?tabSelected=nominees",
    it: "rop/il-mio-profilo?tabSeleziona=Nominato",
    fr: "royal-orchid-plus/profil?onglet=beneficiaire"
  },
  "rop/my-profile": {
    de: "rop/mein-profil",
    it: "rop/il-mio-profilo",
    fr: "royal-orchid-plus/profil"
  },
  "rop/miles-management/mileage-purchase": {
    de: "rop/meilen-management/meilen-kaufen",
    it: "rop/gestione-miglia/acquisto-miglia",
    fr: "rop/gestion-miles/achat-miles"
  },
  "rop/miles-management/extend-expiry-miles": {
    de: "rop/meilen-management/verfallende-meilen-verlangern",
    it: "rop/gestione-miglia/estensione-scadenza-miglia",
    fr: "royal-orchid-plus/gestion-miles/prolonger-validite"
  },
  "rop/miles-management/member-status-calculator/qualifying-miles-calculator": {
    de: "rop/meilen-management/member-status-calculator/qualifying-miles-calculator",
    it: "rop/gestione-miglia/calcolatore-stato-membro/calcolatore-miglia-qualificanti",
    fr: "royal-orchid-plus/gestion-miles/calcul-statut"
  },
  "rop/miles-management/claim-missing-miles": {
    de: "rop/meilen-management/fehlende-meilen-beantragen",
    it: "rop/gestione-miglia/richiedi-miglia-mancanti",
    fr: "rop/gestion-miles/reclamation-miles"
  },
  "rop/miles-management/gift-miles": {
    de: "rop/meilen-management/meilen-verschenken",
    it: "rop/gestione-miglia/regalo-miglia",
    fr: "rop/gestion-miles/offrir-miles"
  },
  "rop/miles-management/transfer-miles": {
    de: "rop/meilen-management/meilen-ubertragen",
    it: "rop/gestione-miglia/trasferimento-miglia",
    fr: "rop/gestion-miles/transfert-miles"
  },
  "spend-miles/flight-upgrades/verify": {
    de: "meilen-einlosen/flug-upgrades/verifizieren",
    it: "spendi-miglia/upgrade-voli/verifica",
    fr: "utiliser-miles/surclassement/verification"
  },
  "rop/spend-miles/search-by-miles": {
    de: "rop/meilen-einlosen/pramien-nach-meilen",
    it: "rop/spendi-miglia/ricerca-per-miglia",
    fr: "rop/depense-miles/recherche-par-miles"
  },
  "business/mice/mice-offers": {
    fr: "entreprise/mice/offres"
  },
  "business/mice/proposal-form": {
    fr: "entreprise/mice/formulaire-proposition"
  },
  "charter-flights/charter-request-form": {
    fr: "vols-prives/formulaire-demande"
  },
  subscribe: {
    de: "abbonnieren",
    it: "aiuto/richiesta-assistenza/",
    fr: "abonnement/sinscrire"
  },
  unsubscribe: {
    de: "abmelden",
    it: "cancellazione-iscrizione",
    fr: "abonnement/se-desinscrire"
  },
  "content/baggage": {
    fr: "content/bagages",
    de: "content/gepack",
    it: "content/bagagli"
  },
  checkin: {
    fr: "content/enregistrement"
  }
};